import { useState } from 'react';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import DataTabs from '@rio-cloud/rio-uikit/DataTabs';
import DataTab from '@rio-cloud/rio-uikit/DataTab';
import useScoreExtractStore from '../services/scoreExtractStore';
import { useNavigate } from 'react-router';
import { useGetAssetsQuery } from '../services/assetsApi';
import { useSelectVehicleStore } from '../services/selectVehicleSlice';
import TableViewToggles from '@rio-cloud/rio-uikit/components/table/TableViewToggles';
import { RouteMap } from '../routes/routeList';
import DashboardTableOperationalDiscipline from '../features/dashboardTableOperationalDiscipline/DashBoardTableOperationalDiscipline';
import useRelationshipStore from '../services/relationshipStore';
import { useSelectAssetsStore } from '../services/selectAssetsStore';


const Title = ({ text, icon, value }: { text: string; icon: React.ReactNode, value: React.ReactNode }) => (
    <div>
        <div>{text}</div>
        <div className='text-bold text-size-18'><span className={`rioglyph ${icon} margin-right-10`}></span>{value}</div>
    </div>
);

export default function OperationalDiscipline() {

    const [tabKey, setTabKey] = useState<string>('');
    const { clearExtractScoreData } = useScoreExtractStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const { currentData } = useGetAssetsQuery();
    const navigate = useNavigate();
    const { selectedAssets } = useSelectAssetsStore();
    const { postScore: relationshipPostScore } = useRelationshipStore();
    const relationshipRoute = `/${RouteMap.get('relationship')}`;
    const assetId = sessionStorage.getItem('assetId');
    const asset = currentData?.items.find((element: { id: any; }) => element.id == assetId);
    
    const tabs = [
        {
            key: 'IT_OPERATIONAL_DISCIPLINE',
            icon: 'rioglyph-clipboard',
            title: 'Disciplina Operacional',
            value: 'Análise por Evento',
            hasData: true
        }
    ];

    return (
        <StatsWidgets>
            <StatsWidget>
                <StatsWidget.Header className='text-left text-size-16'>
                    <ul className="breadcrumb">
                        <li>
                            <span className="btn btn-link btn-link-inline">
                                <span className="rioglyph rioglyph-home margin-right-0">
                                </span>
                                <span className='margin-left-10'>
                                    <a onClick={() => {
                                        clearExtractScoreData();
                                        clearSelectedVehicle();
                                        navigate(relationshipRoute);
                                        relationshipPostScore({assetIds: selectedAssets});
                                    }}>Relacionamento</a>
                                </span>
                            </span>
                        </li>
                        <li className="active">Disciplina Operacionalㅤ-ㅤ<span className='text-bold'>{ asset?.name }</span></li>
                    </ul>
                </StatsWidget.Header>
                <StatsWidget.Body>
                    <DataTabs activeKey={tabKey} onSelectTab={newTabKey => setTabKey(newTabKey)}>
                        {tabs.map((tab, index) => {
                            if (index === 0) {
                                return (
                                    <DataTab key={index} active={true} tabKey={tab.key} title={<Title text={tab.value} icon={tab.icon} value={tab.title} />}>
                                        <DashboardTableOperationalDiscipline viewType={TableViewToggles.VIEW_TYPE_TABLE} />
                                    </DataTab>
                                )
                            }
                        })}
                    </DataTabs>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}